import { defineAsyncComponent } from 'vue';

export default {
	description: 'Источники финансирования',
	forms: {
		edit: {
			panel: {
				width: '60%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '70%'
			},
			config: {
				fields: {
					position_number: {
						description: '№',
						config: {
							width: '80px'
						}
					},
					budget_level: {
						description: 'Уровень бюджета',
						config: {
							width: '160px'
						}
					},
					paragraph: {
						description: 'Параграф',
						config: {
							width: '120px'
						}
					},
					name: {
						description: 'Название',
						config: {
							width: '260px'
						}
					},
					category_details: {
						description: 'Категория / статья / подстатья / элемент',
						config: {
							width: '260px'
						}
					},
					name_full: {
						description: 'Доп. название',
						config: {
							width: '260px'
						}
					}
				}
			}
		}
	}
};

